import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Debounce function to limit how often checkMobile runs
    let resizeTimer;

    const checkMobile = () => {
      const mobile = (window.innerWidth >= 320 && window.innerWidth <= 480)
        ||
        (window.innerWidth >= 480 && window.innerWidth <= 768);
      setIsMobile(mobile);
    };

    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkMobile, 100); // Wait 100ms after last resize event
    };

    // Check on initial load
    checkMobile();

    // Add debounced event listener
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimer);
    };
  }, []);
  return (
    <footer className="footer-container">
      <div className="footer-div">
        <div>
          <img src="/logo512.png" alt="Logo" className="footer-image" />
          <span className="footer-span">GimmeResume</span>
        </div>
        <div className="footer-links">
          <Link to="/support" className="footer-link">Support</Link>
          <Link to="/terms" className="footer-link">Terms</Link>
          <Link to="/privacy-policy" className="footer-link">Privacy</Link>
        </div>
        {!isMobile && (
        <div className="footer-copyright">
          © 2026 GimmeResume. All rights reserved.
          Secure payments powered by Stripe.
        </div>)}
        {isMobile && (
        <div className="footer-copyright">
          © 2026 GimmeResume. All rights reserved.<br />
          Secure payments powered by Stripe.
        </div>)}
      </div>
    </footer>
  );
}

export default Footer;